import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { Heart } from "lucide-react";
import { AdCard } from "@/components/ad-card";
import { useFavorites } from "@/lib/favorites";

export const Route = createFileRoute("/secilmisler")({
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { title: "Seçilmiş elanlar — Albazar.az" },
      { name: "description", content: "Bəyəndiyiniz elanları bir yerdə saxlayın və sonra baxın." },
      { property: "og:title", content: "Seçilmiş elanlar — Albazar.az" },
      { property: "og:description", content: "Bəyəndiyiniz elanlar." },
    
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => {
    const { items: favs } = useFavorites();
    return (
      <div className="container-x py-10">
        <h1 className="text-3xl font-extrabold tracking-tight">Seçilmiş elanlar</h1>
        <p className="mt-1 text-sm text-muted-foreground">{favs.length} elan</p>
        {favs.length === 0 ? (
          <div className="mt-10 flex flex-col items-center gap-3 rounded-3xl border border-border bg-card p-10 text-center shadow-card">
            <Heart className="size-8 text-muted-foreground" />
            <p className="text-sm font-bold">Hələ seçilmiş elanınız yoxdur</p>
            <p className="text-xs text-muted-foreground">
              Elan kartındakı ürək ikonuna toxunaraq bəyəndiyiniz elanları buraya əlavə edin.
            </p>
            <Link
              to="/elanlar"
              search={{ q: "", kateqoriya: "", seher: "", sirala: "yeni" }}
              className="mt-2 rounded-2xl bg-primary px-4 py-2 text-sm font-bold text-primary-foreground"
            >
              Elanlara bax
            </Link>
          </div>
        ) : (
          <div className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-4">
            {favs.map((a, i) => (
              <AdCard key={a.id} ad={a} index={i} />
            ))}
          </div>
        )}
      </div>
    );
  },
});